import { render, staticRenderFns } from "./categoryCar.vue?vue&type=template&id=15a9f77c&"
import script from "./categoryCar.vue?vue&type=script&lang=js&"
export * from "./categoryCar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports